module.exports = __webpack_public_path__ + "img/9791162950135.673df928.jpg";